import { render, staticRenderFns } from "./Detailblog.vue?vue&type=template&id=3e3e9698&"
import script from "./Detailblog.vue?vue&type=script&lang=js&"
export * from "./Detailblog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports